<h2 mat-dialog-title style="color: #0061A2">
    {{title}}
</h2>
<form [formGroup]="newActivity" fxFlexLayout="column" style="width: 100%; margin: 20px 0px;" (ngSubmit)="onConfirm()" autocomplete="off">
    <div mat-dialog-content fxLayout="column">
        <div fxFlex='100'>
            <mat-form-field appearance="outline" style="width: 99%;">
                <mat-label>Fecha</mat-label>
                <input matInput  [matDatepicker]="picker1" formControlName="date">
                <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                <mat-datepicker #picker1></mat-datepicker>
                <mat-error id="required" *ngIf="newActivity.controls['date'].hasError('required')">
                    La fecha es
                    <strong>requerida</strong>
                </mat-error>
            </mat-form-field>
        </div>
        <div fxFlex="100" fxLayout='row' fxLayout.sm='column' fxLayout.xs='column'>
            <div fxFlex="24.9">
                <mat-form-field appearance="outline" style="width: 99%;">
                    <mat-label>Jornada</mat-label>
                    <mat-select formControlName="time">
                        <mat-option *ngFor="let timeDayActivity of timeDayList" [value]="timeDayActivity.id">
                            {{timeDayActivity.name}}
                        </mat-option>
                    </mat-select>
                    <mat-error id="required" *ngIf="newActivity.controls['time'].hasError('required')">
                        La jornada es
                        <strong>requerida</strong>
                    </mat-error>
                </mat-form-field>
            </div>
            <div fxFlex="74.9">
                <mat-form-field appearance="outline" style="width: 99%;">
                    <mat-label>Tipo de Actividad</mat-label>
                    <mat-select formControlName="type">
                        <mat-option *ngFor="let typeActivity of typeActivityList" [value]="typeActivity.id">
                            {{typeActivity.name}}
                        </mat-option>
                    </mat-select>
                    <mat-error id="required" *ngIf="newActivity.controls['type'].hasError('required')">
                        El tipo de actividad es
                        <strong>requerido</strong>
                    </mat-error>
                </mat-form-field>
            </div>
        </div>
        <div fxFlex="100" fxLayout="row">
            <mat-form-field appearance="outline" style="width: 99%;">
                <mat-label>Descripción de la actividad</mat-label>
                <textarea matInput placeholder="Descripción de la actividad..."
                    formControlName="summary"></textarea>
                <mat-error id="required" *ngIf="newActivity.controls['summary'].hasError('required')">
                    La Descripción es
                    <strong>requerida</strong>
                </mat-error>
            </mat-form-field>
        </div>
    </div>

    <div mat-dialog-actions fxLayoutAlign="end none">
        <button mat-button type="button" (click)="onDismiss()">Cerrar</button>
        <button *ngIf='canDelete' mat-raised-button color="warn" type="button" (click)="onDelete()">Borrar</button>
        <button *ngIf='isEditable' mat-raised-button color="primary" type="submit">Guardar</button>
    </div>
</form>